import React from 'react';
import ReactDOM from 'react-dom';
import RedBox from 'redbox-react';
import log from 'loglevel';
import './styles/main.scss';
import App from 'components/App';

// const socket = SocketServer.openConnection();

// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById('root');

let render = () => {
  ReactDOM.render(<App />, MOUNT_NODE);
};

/* eslint-disable-next-line */
if (__DEV__) {
  if (module.hot) {
    const renderApp = render;
    const renderError = error => {
      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE);
    };

    render = () => {
      try {
        renderApp();
      } catch (e) {
        log.error(e);
        renderError(e);
      }
    };
  }

  // Setup hot module replacement
  module.hot.accept(['./components/App', './routes/index'], () =>
    setImmediate(() => {
      ReactDOM.unmountComponentAtNode(MOUNT_NODE);
      render();
    }),
  );
}

/* eslint-disable-next-line */
if (!__TEST__) render();



// WEBPACK FOOTER //
// ./src/main.jsx